import { type EdgeProps, getBezierPath } from '@xyflow/react';

export const BezierEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  label,
}: EdgeProps) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // 计算边的中点
  const midX = (sourceX + targetX) / 2;
  const midY = (sourceY + targetY) / 2;

  // 将文字向上偏移 10 像素
  const labelOffset = 10;
  const labelY = midY - labelOffset;

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      {label ? (
        <text
          x={midX}
          y={labelY}
          textAnchor="middle"
          dominantBaseline="middle"
          style={{
            pointerEvents: 'none',
            fill: '#ADB1B8',
            fontSize: '14px',
            fontWeight: 500,
            background: 'white',
            padding: '4px',
            filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.1))',
          }}
        >
          {label}
        </text>
      ) : null}
    </>
  );
};
